export default __webpack_public_path__ + "static/media/jul3.86800f38.jpg";